import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  notLoggedIn: {
    id: 'studio.QeNjVy',
    defaultMessage:
      'Warning: You are currently not logged in. While logged out you can access all trainings, but progress will not be saved',
  },
});
